<template>
  <v-container>
    <v-card color="#e6eeff" elevation="5" max-width="400"
    v-if="this.user.displayName === null || this.user.uid === ''">
      <v-card-text>
        Também quer criar sua lista de filmes?
        Escolha um dos meios de login abaixo!
      </v-card-text>
      <section
        v-if="user.displayName === null || user.uid === ''"
        id="firebaseui-auth-container"></section>
        <v-card-text></v-card-text>
      </v-card>
  </v-container>
</template>
<script>
import * as firebaseui from 'firebaseui';
import 'firebaseui/dist/firebaseui.css';

export default {
  name: 'Login',
  props: ['showbuttons'],
  data() {
    return {
      user: { displayName: '', photoURL: '' },
    };
  },
  created() {
    this.$firebase.auth().onAuthStateChanged((user) => {
      if (user) {
        this.user = user;
        console.log(this.user.displayName);
      }
    });
  },
  mounted() {
    setTimeout(() => {
      console.log(this.user.displayName);
      if (this.user.displayName === null || this.user.uid === '') {
        const ui = new firebaseui.auth.AuthUI(this.$auth);
        const uiConfig = {
          signInSuccessUrl: '/',
          signInOptions: [
            // this.$firebase.auth.FacebookAuthProvider.PROVIDER_ID,
            this.$firebase.auth.GoogleAuthProvider.PROVIDER_ID,
            this.$firebase.auth.GithubAuthProvider.PROVIDER_ID,
            this.$firebase.auth.TwitterAuthProvider.PROVIDER_ID,
            this.$firebase.auth.EmailAuthProvider.PROVIDER_ID,
          ],
        };
        ui.start('#firebaseui-auth-container', uiConfig);
      }
    }, 1000);
  },
};
</script>
